import api from './jsonapi'

const parseFormula = (formula) => {
  const body = {
    data: {
      formula: formula
    }
  }
  return new Promise((resolve, reject) => {
    api.post('/formulas/parse', body, true) // We can keep cache intact here
    .then((result) => resolve(result.data))
    .catch((error) => reject(error))
  })
}

export default parseFormula



// WEBPACK FOOTER //
// ./src/stores/parse_formula.js